import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[workflowDataHost]',
    standalone: true,
})
export class WorkflowDataDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
        console.log('WorkflowDataDirective');
    }
}
